export default (prefix, value) => value ? prefix + value : '';
